import IsNextYearEarlyRegistrationContext from '@/contexts/IsNextYearEarlyRegistrationContext';
import { useGet } from '@ngt/forms';
import { useContext, useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GeneratedEmailResponse, GenerateEarlyBirdInvoiceEmail, GenerateInvoiceEmail } from '../api/dtos';

const getData = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => response?.data?.result;

const getError = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => (response?.error ?? response?.data);

const getAdditionalState = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => ({
    invoice: response?.data?.result
});

export const useInvoice = (reg?: number, configuration?: SWRConfiguration) => {

    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);

    const request = useMemo(() => {

        return () => {
            if (isNextYearEarlyRegistration) {
                return new GenerateEarlyBirdInvoiceEmail({registrationId: reg});
            }
            else {
                return new GenerateInvoiceEmail({ registrationId: reg });
            }
        };
    }, [reg, isNextYearEarlyRegistration]);

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useInvoice;

